

import { axiosGet, axiosPost } from "../../../react_axios/Axios";
import {
    headers, GET_DRT_LIST,
    GET_DRT_DETAILS,
    UPDATE_DRT, fetchDRTListUrl,
    getDRTDetailsUrl, UPDATE_DRT_CHECKLIST, updateDRTChecklistUrl,
    updateDRTUrl, getDRTSuggestionsUrl, GET_DRT_SUGGESTIONS
} from "../../../utils/constants";
import moment from 'moment';

export const fetchDRTList_action = (ProgramTitle, FromDate, ToDate, Area, ResponsiblePerson) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            ProgramTitle: ProgramTitle,
            FromDate: FromDate != '' && FromDate != null ? moment(FromDate).format("YYYY-MM-DD") : '',
            ToDate: ToDate != '' && ToDate != null ? moment(ToDate).format("YYYY-MM-DD") : '',
            HallId: Area,
            ResponsiblePerson: ResponsiblePerson,
        }
        console.log("getPaymentList_action Action------->", params)

        const res = await axiosGet(fetchDRTListUrl, params, headers)

        dispatch({
            type: GET_DRT_LIST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const updateDRTChecklist_action = (
    DailyRoutineChecklistHdrID, checkList) => async (dispatch) => {
        try {
            const mapData = {
                UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
                ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
                DailyRoutineChecklistHdrID: DailyRoutineChecklistHdrID,
                checkList: checkList
            }
            console.log("addVisaApplication_action------->", mapData)
            const res = await axiosPost(updateDRTChecklistUrl, mapData, headers)

            dispatch({
                type: UPDATE_DRT_CHECKLIST,
                payload: res
            })
            return Promise.resolve(res)
        } catch (error) {
            return Promise.reject(error)
        }
    }

export const getDRTDetails_action = (DailyRoutineChecklistHdrID, DailyRoutineChecklistHallID, DailyRoutineChecklistDateID, DailyRoutineChecklistScheduleTimeID) => async (dispatch) => {
    try {
        const params = {
            // UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            AccountID: sessionStorage.getItem("AccountIDSS") ?? null,
            DailyRoutineChecklistHallID: DailyRoutineChecklistHallID,
            DailyRoutineChecklistHdrID: DailyRoutineChecklistHdrID,
            DailyRoutineChecklistDateID: DailyRoutineChecklistDateID,
            DailyRoutineChecklistScheduleTimeID: DailyRoutineChecklistScheduleTimeID
        }
        console.log("getPaymentList_action Action------->", params)

        const res = await axiosGet(getDRTDetailsUrl, params, headers)

        dispatch({
            type: GET_DRT_DETAILS,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getDRTSuggestions_action = (DailyRoutineChecklistHdrID, DailyRoutineChecklistHallID, DailyRoutineChecklistDateID, DailyRoutineChecklistScheduleTimeID) => async (dispatch) => {
    try {
        const params = {
            // UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            // ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            DailyRoutineChecklistHallID: DailyRoutineChecklistHallID,
            DailyRoutineChecklistHdrID: DailyRoutineChecklistHdrID,
            DailyRoutineChecklistDateID: DailyRoutineChecklistDateID,
            DailyRoutineChecklistScheduleTimeID: DailyRoutineChecklistScheduleTimeID
        }
        console.log("getPaymentList_action Action------->", params)

        const res = await axiosGet(getDRTSuggestionsUrl, params, headers)

        dispatch({
            type: GET_DRT_SUGGESTIONS,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const updateDRT_action = (List, proname, hallstr, dateTime, PersonName) => async (dispatch) => {
    try {
        const mapData = {
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            List: List,
            PersonName: PersonName,
            Task: proname,
            Hall: hallstr,
            DateTime: dateTime
        }
        console.log("addVisaApplication_action------->", mapData)
        const res = await axiosPost(updateDRTUrl, mapData, headers)

        dispatch({
            type: UPDATE_DRT,
            payload: res
        })
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}